module.exports = function (lesson, sentence, popup_mod) {
  var s = sentence.sentence_text.replaceAll('\\', '');
  var s2 = sentence.sentence_text.replaceAll('\\', '');
  var p = sentence.speaker_text.replaceAll('\\', '');
  var pinyin_visible = 'none';
  var english_visible = 'none';
  if (popup_mod.app.options.popup.display.pinyin == 1) {
    pinyin_visible = 'block';
  }
  if (popup_mod.app.options.popup.display.english == 1) {
    english_visible = 'block';
  }
  try {
    s2 = switch_display_mode_in_string(s2, 'pinyin', 'simplified');
    if (popup_mod.app.options.popup.display.traditional == 1) {
      s = switch_display_mode_in_string(s, 'traditional', 'simplified');
      p = switch_display_mode_in_string(p, 'traditional', 'simplified');
    }
  } catch (err) {}
  return "\n    <tr class=\"sentence\">\n      <td class=\"sentence-player\"></td>\n      <td class=\"sentence-speaker\">".concat(p, "</td>\n      <td class=\"sentence-data\">\n\t<div class=\"lesson_sentence_source\" id=\"lesson_sentence_source_").concat(sentence.id, "\">").concat(s, "</div>\n\t<div class=\"lesson_sentence_pinyin\" id=\"lesson_sentence_pinyin_").concat(sentence.id, "\" style=\"display:").concat(pinyin_visible, "\">").concat(s2, "</div>\n\t<div class=\"lesson_sentence_translation\" id=\"lesson_sentence_translation_").concat(sentence.id, "\" style=\"display:").concat(english_visible, "\">").concat(sentence.sentence_translation, "</div>\n      </td>\n    </tr>\n  ");
};